import { jsx as L } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ L(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.25C16.4812 2.25 15.25 3.48122 15.25 5C15.25 6.51878 16.4812 7.75 18 7.75C19.5188 7.75 20.75 6.51878 20.75 5C20.75 3.48122 19.5188 2.25 18 2.25ZM9.34864 9.25H7C6.70361 9.25 6.43502 9.42455 6.31464 9.6954L4.73482 13.25H8.10358L9.34864 9.25ZM2.31464 18.6954L4.06815 14.75H7.63668L6.08035 19.75H3C2.74612 19.75 2.50948 19.6216 2.37113 19.4087C2.23279 19.1958 2.21153 18.9274 2.31464 18.6954ZM7.65134 19.75L9.20767 14.75L14.7923 14.75L16.3487 19.75H7.65134ZM17.9196 19.75L16.3633 14.75L19.6411 14.75L21.6658 18.6548C21.7864 18.8873 21.7769 19.1658 21.6409 19.3896C21.5048 19.6134 21.2619 19.75 21 19.75H17.9196ZM15.8964 13.25L18.8633 13.25L16.9992 9.65476C16.8702 9.40609 16.6134 9.25 16.3333 9.25H14.6514L15.8964 13.25ZM9.67456 13.25L14.3254 13.25L13.0804 9.25H10.9196L9.67456 13.25Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
